import { ElementsButton, ErrorBanner } from '../../index';
import { useGenerateLinkToken, useUpdatePlaidConnection } from '../../../Plaid/hooks';
import { useElementsEnvironmentContext } from '../../../environment';
import { useTranslation } from 'react-i18next';

export const PlaidConnectionErrorBanner = ({
  householdID,
  plaidItemID,
}: {
  householdID: string;
  plaidItemID: string;
}) => {
  const linkToken = useGenerateLinkToken(householdID, plaidItemID);
  const { open } = useUpdatePlaidConnection({ householdID, plaidItemID, linkToken });
  const { app } = useElementsEnvironmentContext();
  const { t: tError } = useTranslation('error');

  return (
    <ErrorBanner
      errorText={tError('connected-account-error')}
      actionButton={
        app === 'client' ? (
          <ElementsButton
            label={tError('connected-account-error-action')}
            theme={'danger-solid'}
            className={'ml-2 min-w-28'}
            onClick={() => open()}
          />
        ) : undefined
      }
    />
  );
};
